import template from './view_perf_objective_plan.html';
import * as Utils from '../../lib/savanna_utils.js';

class ViewPerfObjectivePlanViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.date = ko.observable(moment().format('YYYY-MM-DD hh:mm'));
		this.employment_info = ko.observable();
		this.logged_in_employee = ko.observable();
		this.objective_plan = ko.observable();
		this.title = ko.observable();
		this.performance_cycle_id = ko.observable();
		this.progress = ko.observable();
		this.rating_options = ko.observable();
		this.employee_rating = ko.observable();
		this.employee_ratings = ko.observableArray();
		this.employee_note = ko.observable();
		this.manager_id = ko.observable();
		this.employee_id = ko.observable();
		this.manager_note = ko.observable();
		this.manager_rating = ko.observable();
		this.manager_ratings = ko.observableArray();
		this.rating_system_type = ko.observable();
		this.rating_method = ko.observableArray();
		this.objectives = ko.observable();
		this.collapse_table = ko.observable(false);

		this.is_logged_in = ko.computed(() => {
			return this.logged_in_employee() === this.employee_id();
		}, this);

		this.is_manager = ko.computed(() => {
			return this.logged_in_employee() === this.manager_id();
		}, this);

		this.view_date = ko.computed(() => {
			return 'View/Print Date:  ' + this.date();
		});

		this.current_step = ko.computed(() => {
			if (this.progress())
			{
				let items = this.progress().filter((item) => item.status === 'In Progress');
				return items.length > 0 ? items[0] : null;
			}
			else
				return null;
		});
	};

	btn_toggle_collapse()
	{
		this.collapse_table(!this.collapse_table());
	}

	close()
	{
		this.dialog.close();
	}

	btn_print_doc()
	{

	}

	btn_download_doc()
	{
		let data = [];
		data.push(["Objective plan", this.employment_info().name]); 
		data.push([]); 
		data.push(["Plan details", this.view_date()]);

		if (Array.isArray(this.employment_info())) {
			if (this.employment_info().length > 0) {
				data.push(["Employee Code", "Employee Name", "Manager"]);
				this.employment_info().forEach(emp => {
						data.push([
								emp.code || "N/A", 
								emp.name || "N/A", 
								emp.managers || "N/A"
						]);
						});
			}
		} else {
			if (this.employment_info()) {
				data.push(["Employee Code", "Employee Name", "Manager"]);
				let emp = this.employment_info();
				data.push([
						emp.code || "N/A", 
						emp.name || "N/A", 
						emp.managers || "N/A"
				]);
			}
		}

		data.push([]);
		if (this.objective_plan()) {
			data.push(["Cycle", "Setup Date", "Due Date", "Rating System", "Status"]);
			let obj = this.objective_plan();
			data.push([
					obj.cycle_name || "N/A", 
					obj.setup_date || "N/A", 
					obj.due_date || "N/A",
					obj.rating_method_name || "N/A",
					obj.status || "N/A"
			]);
		}

		data.push([]);
		data.push(["Progress details"]);
		data.push(["Step Sequence", "Step Name", "Status"]);
		ko.utils.arrayForEach(this.progress(), function(obj) {
				data.push([obj.step_sequence, obj.name, obj.status]);
				});

		data.push([]);
		data.push(["Overall feedback: Rating method"]);
		data.push(["Rating Method", "Description", "Employee Rating", "Manager Rating", "Employee Note", "Manager Note"]);
		data.push([
				this.rating_method().name || "N/A",
				this.rating_method().description || "N/A",
				this.employee_rating() || this.employee_ratings().join(", ") || "N/A",
				this.manager_rating() || this.manager_ratings().join(", ") || "N/A",
				this.employee_note() || "N/A",
				this.manager_note() || "N/A"
		]);

		data.push(["Overall feedback"]);
		data.push(["Objective No.", "Name", "Description", "Expected Outcomes", "Measure (KPI)", "Linked Company Objectives", "Manager Feedback", "Employee Feedback"]);

		ko.utils.arrayForEach(this.objectives(), function(obj) {
				let linkedObjectives = obj.linked_company_objectives ? obj.linked_company_objectives().map(o => o.display_name).join("; ") : "N/A";
				data.push([
						obj.sequence || "N/A",
						obj.name || "N/A",
						obj.description || "N/A",
						obj.expected_result || "N/A",
						obj.measure || "N/A",
						linkedObjectives,
						obj.manager_feedback || "N/A",
						obj.employee_feedback || "N/A"
				]);
			});

		let csvContent = "data:text/csv;charset=utf-8," 
			+ data.map(e => e.join(",")).join("\n");

		let encodedUri = encodeURI(csvContent);
		let link = document.createElement("a");
		link.setAttribute("href", encodedUri);
		link.setAttribute("download", "Objective_Plan.csv");
		document.body.appendChild(link);

		link.click();

		document.body.removeChild(link);


	}

	btn_share_doc()
	{

	}
};

class ViewPerfObjectivePlanPage
{
	constructor (bindings)
	{
		this.viewModel = new ViewPerfObjectivePlanViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
		if (this.bindings)
		{
			this.viewModel.logged_in_employee(parseInt(localStorage.getItem('employee_id')));
			this.viewModel.employment_info(ko.mapping.toJS(this.bindings.employee_info));
			this.viewModel.objective_plan(this.bindings.data);
			let name = this.bindings.data.firstname;
			let surname_inital = this.bindings.data.surname;
			this.viewModel.title(name + ' ' + surname_inital.charAt(0) + ' - ' + this.bindings.data.name);
			this.viewModel.performance_cycle_id(this.bindings.data.performance_cycle_id);
			this.viewModel.progress(this.bindings.progress);
			this.viewModel.manager_id(this.bindings.manager_id);
			this.viewModel.employee_id(this.bindings.employee_id);
			this.viewModel.rating_method({name: this.bindings.data.rating_method_name, description: this.bindings.data.rating_method_description, type: this.bindings.data.rating_method_type});

			this.get_overall_feedack(this.bindings.data);
			this.get_obj_details(this.bindings.data);
		}
	}

	async get_overall_feedack(data)
	{
		//get rating system options:
		try {
			if (data)
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'rating_system_option',
					schema: 'perfm_manage',
					filter: [{
						field: 'rating_system_id',
						operand: '=',
						value: data.rating_system_id
					}]
				});
				if (res.status != 'ERROR')
					this.viewModel.rating_options(res.records);
			}
			else
				return;

		} catch (error) {
			console.error(error);
		}

		try {
			if (data)
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'emp_manager_rating',
					schema: 'perfm_manage',
					filter: [{
						field: 'objective_plan_id',
						operand: '=',
						value: data.objective_plan_id
					}]
				});
				if (res.status != 'ERROR')
				{
					res.records.forEach(record => {
						if (record.employee_id === this.bindings.data.employee_id)
						{
							this.viewModel.employee_note(record.notes || '');
							if (this.viewModel.rating_method().type === 'multiselect')
							{
								let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
								this.viewModel.employee_ratings(rating_array);
							}
							else if (this.viewModel.rating_method().type === 'single-select')
							{
								let rating = parseInt(record.rating);
								this.viewModel.employee_rating(rating);
							}
							else
								this.viewModel.employee_rating(record.rating);
						}
						else if (record.employee_id === this.viewModel.manager_id())
						{
							this.viewModel.manager_note(record.notes || '');
							if (this.viewModel.rating_method().type === 'multiselect')
							{
								let rating_array = record.rating ? record.rating.split(',').map(item => parseInt(item.trim(), 10)) : [];
								this.viewModel.manager_ratings(rating_array);
							}
							else if (this.viewModel.rating_method().type === 'single-select')
							{
								let rating = parseInt(record.rating);
								this.viewModel.manager_rating(rating);
							}
							else
								this.viewModel.manager_rating(record.rating);
						}
					});
				}
			}
			else
				return;

		} catch (error) {
			console.error(error);
		}
	}

	
	async get_obj_details(data)
	{
		if (data)
		{
			let objective_plan_id = parseInt(this.bindings.data.objective_plan_id);
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'v_objectives_for_objective_plan',
				schema: 'perfm_manage',
				sort_order: 'ASC',
				sort_field: 'sequence',
				filter: [{
					field: 'objective_plan_id',
					operand: '=',
					value: objective_plan_id
				}]
			});
			if (res.status != 'ERROR')
			{
				let items = res.records.map((x) => ({
					...x,
					editing: ko.observable(false),
					editing_emp_feedback: ko.observable(false),
					editing_manager_feedback: ko.observable(false),
					linked_company_objectives: ko.observable((x.linked_company_objectives || []).map((x) => ({
						...x,
						display_name: x.number + ' ' + x.description
						// Add a description to use as title when hovering that will show if it is a subgoal, goal, or entire objective and to who it belongs
					})))
				}));
				// Ensure proper numeric sorting by sequence
				items.sort((a, b) => {
					// Convert sequence to numbers and compare
					return parseInt(a.sequence) - parseInt(b.sequence);
				});
				this.viewModel.objectives(items);
			}
		}
	}
};

export default {
	name: 'ViewPerfObjectivePlan',
	dialog_class: ViewPerfObjectivePlanPage,
	template: template,
	template_filename: 'translation/dialogs/view_perf_objective_plan',
	provider: 'ps'
};
